/**
 * Organismes de financement (créanciers gagistes) connus d'AssurAli, tels que
 * son extranet les propose sur la fiche projet — liste relevée le 24/09/2026
 * par la sonde d'inventaire de l'agent de tarification (122 entrées).
 * Deux familles : les banques et sociétés de crédit, que le prospect sait
 * nommer (19) ; les loueurs, dont le nom figure sur la carte grise
 * (titulaire, case C.1) pour une LOA ou une LLD (103).
 *
 * Choisir une suggestion reprend l'écriture exacte de la compagnie : l'agent
 * de tarification la retrouve sans arbitrage. Une saisie libre reste
 * possible, l'agent retient alors l'organisme le plus proche (PER-2439/2440).
 *
 * Pour rafraîchir : relancer la sonde d'inventaire des fiches AssurAli et
 * régénérer ce fichier (l'extranet peut ajouter des loueurs).
 */
export const ORGANISMES_FINANCEMENT = [
  { libelle: "BFC OI", famille: "organisme" },
  { libelle: "BPCE", famille: "organisme" },
  { libelle: "BPIFRANCE FINANCEMENT", famille: "organisme" },
  { libelle: "BRED", famille: "organisme" },
  { libelle: "CA LEASING", famille: "organisme" },
  { libelle: "CAISSE EPARGNE", famille: "organisme" },
  { libelle: "CAMBA 164 - CREDIT MODERNE", famille: "organisme" },
  { libelle: "CMOI", famille: "organisme" },
  { libelle: "CREDIT AGRICOLE", famille: "organisme" },
  { libelle: "CREDIT MODERNE OCEAN INDIEN", famille: "organisme" },
  { libelle: "CREDIT MUTUEL LEASING", famille: "organisme" },
  { libelle: "DINDAR AUTOS", famille: "organisme" },
  { libelle: "EKOJARDIN", famille: "organisme" },
  { libelle: "INTER INVEST FINANCEMENT", famille: "organisme" },
  { libelle: "LA BANQUE", famille: "organisme" },
  { libelle: "LIXXBAIL", famille: "organisme" },
  { libelle: "SOFIDER", famille: "organisme" },
  { libelle: "SOFIDOM", famille: "organisme" },
  { libelle: "SOREFI", famille: "organisme" },
  { libelle: "AMARYLLIS 2125", famille: "loueur" },
  { libelle: "ATHENA 2222", famille: "loueur" },
  { libelle: "CALANTHE 2023", famille: "loueur" },
  { libelle: "CAMBA 166", famille: "loueur" },
  { libelle: "CAMBA 323", famille: "loueur" },
  { libelle: "CAMBA 405", famille: "loueur" },
  { libelle: "CAMBA 408", famille: "loueur" },
  { libelle: "CAMBA 543", famille: "loueur" },
  { libelle: "CAMBA 921", famille: "loueur" },
  { libelle: "CAMBA DOM 053", famille: "loueur" },
  { libelle: "FILAO 2324", famille: "loueur" },
  { libelle: "GUARANA DOM 032", famille: "loueur" },
  { libelle: "MARVIC 217", famille: "loueur" },
  { libelle: "MARVIC 257", famille: "loueur" },
  { libelle: "MARVIC 261", famille: "loueur" },
  { libelle: "MARVIC 264", famille: "loueur" },
  { libelle: "MARVIC 266", famille: "loueur" },
  { libelle: "MARVIC 295", famille: "loueur" },
  { libelle: "MARVIC 303", famille: "loueur" },
  { libelle: "MARVIC 314", famille: "loueur" },
  { libelle: "MARVIC 378", famille: "loueur" },
  { libelle: "MARVIC 476", famille: "loueur" },
  { libelle: "MARVIC 481", famille: "loueur" },
  { libelle: "MARVIC 753", famille: "loueur" },
  { libelle: "NERVILIA 2122", famille: "loueur" },
  { libelle: "ODEON 53", famille: "loueur" },
  { libelle: "OXALYS 2223", famille: "loueur" },
  { libelle: "PASSY G 56", famille: "loueur" },
  { libelle: "PASSY H82", famille: "loueur" },
  { libelle: "PASSY H88", famille: "loueur" },
  { libelle: "PASSY K91", famille: "loueur" },
  { libelle: "PASSY O 35 SNC", famille: "loueur" },
  { libelle: "PASSY S 52", famille: "loueur" },
  { libelle: "PASSY S 85", famille: "loueur" },
  { libelle: "PASSY S 92", famille: "loueur" },
  { libelle: "PASSY U 31", famille: "loueur" },
  { libelle: "PASSY U 9", famille: "loueur" },
  { libelle: "PASSY U90", famille: "loueur" },
  { libelle: "PASSY V 44", famille: "loueur" },
  { libelle: "PASSY V 91", famille: "loueur" },
  { libelle: "PEREIRE 1", famille: "loueur" },
  { libelle: "PEREIRE 4", famille: "loueur" },
  { libelle: "PEREIRE A 25", famille: "loueur" },
  { libelle: "PEREIRE A 65", famille: "loueur" },
  { libelle: "PEREIRE A 79", famille: "loueur" },
  { libelle: "PHONING RENOUV STEPHANE", famille: "loueur" },
  { libelle: "PITAYA 050", famille: "loueur" },
  { libelle: "PITAYA 263", famille: "loueur" },
  { libelle: "PITAYA 280", famille: "loueur" },
  { libelle: "PITAYA 444", famille: "loueur" },
  { libelle: "PITAYA 530", famille: "loueur" },
  { libelle: "PITAYA DOM 042", famille: "loueur" },
  { libelle: "QUININ 15", famille: "loueur" },
  { libelle: "RIO 13", famille: "loueur" },
  { libelle: "RIO 35", famille: "loueur" },
  { libelle: "RIO 40", famille: "loueur" },
  { libelle: "RIO 84", famille: "loueur" },
  { libelle: "SAKE 99", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 2202", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 2909", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 2931", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3100", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3101", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3102", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3277", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3285", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3361", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3375", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3398", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3408", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3464", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3477", famille: "loueur" },
  { libelle: "SALAZIE LOCATION 3478", famille: "loueur" },
  { libelle: "SAMOA 28", famille: "loueur" },
  { libelle: "SAMOA 54", famille: "loueur" },
  { libelle: "SEVRES 0 13", famille: "loueur" },
  { libelle: "SEVRES 04", famille: "loueur" },
  { libelle: "SEVRES 086", famille: "loueur" },
  { libelle: "SEVRES A 41", famille: "loueur" },
  { libelle: "SEVRES A 48", famille: "loueur" },
  { libelle: "SEVRES I 93", famille: "loueur" },
  { libelle: "SEVRES P75", famille: "loueur" },
  { libelle: "SEVRES Q 1", famille: "loueur" },
  { libelle: "SEVRES R 13", famille: "loueur" },
  { libelle: "SEVRES V 9", famille: "loueur" },
  { libelle: "SNC PINAKI 2322", famille: "loueur" },
  { libelle: "TERNES I 58", famille: "loueur" },
  { libelle: "TONGA 81", famille: "loueur" },
  { libelle: "TULA 13", famille: "loueur" },
  { libelle: "UKYO 97", famille: "loueur" },
  { libelle: "UKYO 98", famille: "loueur" },
  { libelle: "ULEX 29", famille: "loueur" },
  { libelle: "ULEX 34", famille: "loueur" },
  { libelle: "UMBOI 26", famille: "loueur" },
  { libelle: "UMBOI 99", famille: "loueur" },
  { libelle: "UZI 56", famille: "loueur" },
  { libelle: "VANA 52", famille: "loueur" },
  { libelle: "VANA 61", famille: "loueur" },
  { libelle: "WAIGEO 13", famille: "loueur" },
  { libelle: "WAKA 48", famille: "loueur" },
  { libelle: "WALLIS 23", famille: "loueur" },
  { libelle: "WEDA 62", famille: "loueur" },
  { libelle: "salazie location 3387", famille: "loueur" },
];

/** Entrées du contrôle « autocomplete » du back-office : la valeur enregistrée est le libellé lui-même. */
export const ORGANISMES_FINANCEMENT_DATAS = ORGANISMES_FINANCEMENT.map((o) => ({
  id: o.libelle,
  name: o.libelle,
  famille: o.famille,
}));
